import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    { q: 'How does PreciseCA sync data from Tally?', a: 'PreciseCA uses a lightweight connector that integrates with your existing Tally setup. It automatically syncs data in real-time without requiring any manual intervention.' },
    { q: 'Is my data secure with PreciseCA?', a: 'Yes, we use enterprise-grade encryption and host on Microsoft Azure servers. All data is encrypted at rest and in transit with role-based access controls.' },
    { q: 'Can I access data in real-time?', a: 'Yes, PreciseCA provides real-time data synchronization across all your branches, giving you up-to-the-minute financial insights.' },
    { q: 'How many branches can I connect?', a: 'PreciseCA scales from 3 to 50+ branches depending on your plan. Enterprise Plus offers unlimited branch connectivity.' },
    { q: 'Is there a free trial available?', a: 'Yes! We offer a free trial so you can experience the full power of PreciseCA before committing to a plan.' },
    { q: 'Do I need to change my existing Tally setup?', a: 'No, PreciseCA works with your existing Tally installation. No modifications to your current setup are required.' },
    { q: 'What support is available?', a: 'We provide dedicated support via phone, email, and chat. Enterprise customers get priority support with a dedicated account manager.' },
  ];

  return (
    <section id="faq" className="faq">
      <div className="container">
        <h2 className="section-title">Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqs.map((item, i) => (
            <div key={i} className={`faq-item ${openIndex === i ? 'open' : ''}`}>
              <button className="faq-question" onClick={() => setOpenIndex(openIndex === i ? null : i)}>
                <span>{item.q}</span>
                <span className="faq-toggle">{openIndex === i ? '−' : '+'}</span>
              </button>
              {openIndex === i && <div className="faq-answer"><p>{item.a}</p></div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
